import { useState, useRef } from 'react';
import { HiOutlineChevronUp, HiOutlineChevronDown } from 'react-icons/hi';
import CloudPlatforms from '../images/CloudPlatforms.svg';
import EnterpriseSystems from '../images/EnterpriseSystems.svg';
import MobileSolutions from '../images/MobileSolutions.svg';

const IntegrationCapabilities = () => {

//Dropdown content of How we help section
const [isOpen, setIsOpen] = useState(false);

const toggleSection = (section) => {
setIsOpen((prev) => ({
    ...prev,
    [section]: !prev[section],
}));
};
const contentRef = useRef(null);

    return (
        <>
        <div className='bg-integrationCapabilities bg-cover bg-no-repeat'>
            <div className='bg-[#342E6D80] py-12 lg:py-16 xl:py-24 flex flex-col items-center'>
                <div className='flex flex-col items-center mb-8'>
                    <h1 className='text-white font-uiBold text-center text-4xl xl:text-5xl'>Integration Capabilities</h1>
                    <p className='text-[#CCCCCC] font-symbol text-xl lg:text-2xl text-center mx-4 my-4'>Seamless integration with existing systems and platforms</p>
                </div>

                <div className='pt-8 lg:pt-16 lg:w-9/12 xl:w-8/12 mx-4 sm:mx-10 lg:mx-12 grid grid-flow-row gap-4 lg:gap-8'>
                    {/* 0.625 10px border */}
                    <div className="rounded-xl p-3 sm:p-6 border-l-[0.625rem] bg-white border-[#878DC1] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('cloudPlatforms')}
                        aria-expanded={isOpen['cloudPlatforms']}
                        aria-controls="cloudPlatforms-content"
                        role="button"
                        aria-label="Toggle Cloud Platforms Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={CloudPlatforms} alt="Cloud Platforms"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Cloud Platforms</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['cloudPlatforms'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="cloudPlatforms-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['cloudPlatforms']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["cloudPlatforms"] ? "max-h-screen" : "max-h-0"}`}>
                            <h2 className='text-[var(--lightgray)] font-symbol ps-3 text-base my-6'>
                            Integration with major cloud providers
                            </h2>
                            <ul className="text-[var(--lightgray)] font-symbol ps-3 list-inside list-disc text-base my-6 space-y-1 lg:space-y-2">
                                <li>AWS IoT Core</li>
                                <li>Azure IoT Hub</li>
                                <li>Google Cloud IoT</li>
                                <li>Custom Cloud Solutions</li>
                            </ul>
                        </div>
                    </div>

                    <div className="rounded-xl p-3 sm:p-6 border-l-[0.625rem] bg-white border-[#878DC1] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('enterpriseSystems')}
                        aria-expanded={isOpen['enterpriseSystems']}
                        aria-controls="enterpriseSystems-content"
                        role="button"
                        aria-label="Toggle Enterprise Systems Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={EnterpriseSystems} alt="Enterprise Systems"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Enterprise Systems</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['enterpriseSystems'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="enterpriseSystems-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['enterpriseSystems']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["enterpriseSystems"] ? "max-h-screen" : "max-h-0"}`}>
                            <h2 className='text-[var(--lightgray)] font-symbol ps-3 text-base my-6'>
                            Connection with business systems
                            </h2>
                            <ul className="text-[var(--lightgray)] font-symbol ps-3 list-inside list-disc text-base my-6 space-y-1 lg:space-y-2">
                                <li>ERP Integration</li>
                                <li>CRM Systems</li>
                                <li>Asset Management</li>
                                <li>Analytics Platforms</li>
                            </ul>
                        </div>
                    </div>

                    <div className="rounded-xl p-3 sm:p-6 border-l-[0.625rem] bg-white border-[#878DC1] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('mobileSolutions')}
                        aria-expanded={isOpen['mobileSolutions']}
                        aria-controls="mobileSolutions-content"
                        role="button"
                        aria-label="Toggle Mobile Solutions Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={MobileSolutions} alt="Mobile Solutions"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Mobile Solutions</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['mobileSolutions'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="mobileSolutions-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['mobileSolutions']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["mobileSolutions"] ? "max-h-screen" : "max-h-0"}`}>
                            <h2 className='text-[var(--lightgray)] font-symbol ps-3 text-base my-6'>
                            Mobile app integration and development
                            </h2>
                            <ul className="text-[var(--lightgray)] font-symbol ps-3 list-inside list-disc text-base my-6 space-y-1 lg:space-y-2">
                                <li>iOS Development</li>
                                <li>Android Development</li>
                                <li>Cross-platform Solutions</li>
                                <li>API Integration</li>
                            </ul>
                        </div>
                    </div>
                    {/* Dropdown section ends */}
                </div>
            </div>
        </div>
            
            {/* IntegrationCapabilities section ends */}
        </>
    )
}

export default IntegrationCapabilities